import MeshtasticWeatherStation from './weather/MeshtasticWeatherStation';

function WeatherStationPage() {
  return (
    <div className="min-h-screen bg-[#f8f4ea] text-[#18271e]">
      <section className="border-b border-[#d8d0be] bg-[#f8f4ea] px-0 py-4 sm:px-4 sm:py-6 lg:px-8 lg:py-10">
        <div className="mx-auto max-w-[76rem]">
          <MeshtasticWeatherStation />
        </div>
      </section>
    </div>
  );
}

export default WeatherStationPage;
